import { CreateProfile, ProfileInvalidationProvider } from "@amber/profiles/ui";
import { AFTER_PLAN_CHANGE, ON_PLAN_CONFLICT } from "@amber/collection/ui";
import { ProfilePage } from "./ProfilePage";
import { Roster } from "./Roster";
import type { ProfilesSearch } from "./search";

const PROFILE_INVALIDATION = { invalidate: AFTER_PLAN_CHANGE, invalidateOnConflict: ON_PLAN_CONFLICT };

export function ProfilesView({
  personId,
  search,
  onSearch,
  onOpen,
}: {
  personId: string | null;
  search: ProfilesSearch;
  onSearch: (next: ProfilesSearch) => void;
  onOpen: (id: string | null) => void;
}) {
  return (
    <ProfileInvalidationProvider value={PROFILE_INVALIDATION}>
      <div className="relative flex min-h-0 flex-1">
        {personId ? (
          <ProfilePage
            personId={personId}
            tab={search.tab ?? "overview"}
            history={search.history ?? "all"}
            coverage={search.window ?? 90}
            onSearch={(patch) => {
              onSearch({ ...search, ...patch });
            }}
          />
        ) : (
          <Roster
            search={search}
            onSearch={onSearch}
            onOpen={(id) => {
              onOpen(id);
            }}
          />
        )}
        {search.new === "1" ? (
          <CreateProfile
            onClose={() => {
              onSearch({ ...search, new: undefined });
            }}
          />
        ) : null}
      </div>
    </ProfileInvalidationProvider>
  );
}
